import { render, staticRenderFns } from "./Matrixrates.vue?vue&type=template&id=01763d62"
import script from "./Matrixrates.vue?vue&type=script&lang=js"
export * from "./Matrixrates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports